














import { Component, Vue } from "vue-property-decorator";
import moment from "moment";

@Component
export default class ClassName extends Vue {
  private greyFilter = false;

  mounted() {
    // this.greyFilter = moment().format("D") === "4" ?true: false;
  }
}
